<template>
    <MglMap :accessToken="accessToken" :center="center" :mapStyle.sync="mapStyle" :zoom="zoom" @load="onMapLoad"
            id="map">
<!--        <MglPopup-->
<!--                v-if="popupFeature"-->
<!--                :coordinates="popupFeature.geometry.coordinates[0][0]"-->
<!--                anchor="top"-->
<!--                class="popup"-->
<!--                :close-button="true"-->
<!--                :showed="true"-->
<!--                ref="popup"-->
<!--                :only-text="true"-->
<!--        >Hello world from wrapped popup!</MglPopup>-->
        <MglNavigationControl position="top-right"/>

        <MglGeojsonLayer
                :layer="geoJsonLayer"
                :source="geoJsonSource"
                layerId="departamentos-provincia"
                sourceId="departamentos"
        />

    </MglMap>
</template>
<script>
    import {MglGeojsonLayer, MglMap, MglNavigationControl} from "vue-mapbox"; //, MglPopup
    import Mapbox from "mapbox-gl";

    export default {
        name: "Mapa",
        components: {
            MglMap,
            MglNavigationControl,
            MglGeojsonLayer,
            // MglPopup
        },
        props: {
            departamentos: {
                type: Array
            },
            pintarPor: {
                type: String
            }
        },
        data: function () {
            return {
                accessToken: 'pk.eyJ1IjoibWFyaWFub3phcGF0ZXJvIiwiYSI6ImNrNWE5aGtsODB1NDYzbHBuOHR3OW5obHgifQ.cwz-h6JATCuyHp79gWR3Iw',
                // mapStyle: 'mapbox://styles/mapbox/outdoors-v11',
                mapStyle: 'mapbox://styles/mapbox/streets-v11',
                center: [-60.0, -37.0],
                zoom: 5,
                popupFeature: null,
                popupCoordinates: [-60.0, -37.0],
                // popupShowed: true,
                geoJsonSource: {
                    type: 'geojson',
                    data: {
                        id: "departamentos",
                        type: "FeatureCollection",
                        name: "deptos_baires",
                        crs: {"type": "name", "properties": {"name": "urn:ogc:def:crs:OGC:1.3:CRS84"}},
                        features: []
                    },
                },
                geoJsonLayer: {
                    'id': 'layer-departamentos',
                    'source': 'departamentos',

                    'type': 'fill',
                    'paint': {
                        'fill-color': 'rgba(255, 255, 255, 0.1)',
                        'fill-outline-color': 'blue',
                    },

                    // 'filter': ['==', ['get', 'cantidad_1'], '10']
                }
            }
        },
        watch: {
            'departamentos': function () {
                this.init();
            },
            'pintarPor': function () {
                this.aplicarFiltro();
            }
        },
        created() {
            this.mapbox = Mapbox;
        },
        methods: {
            onMapLoad({map}) {
                this.map = map;
                //console.log("map", map);

                // Working with 'click' as it is easier to troubleshoot.
                this.map.on('click', 'layer-departamentos', (e) => {
                    this.map.getCanvas().style.cursor = 'pointer';
                    const feature = e.features[0];
                    this.popupFeature = feature;
                    console.log("feature", feature);
                    console.log("feature", feature.geometry.coordinates[0][0]);
                    this.$emit('featureClicked', feature);
                });
            },
            init() {
                // departamentos.forEach(function (departamento) {
                //     console.log(departamento.properties.link);
                // });
                // this.geoJsonSource.data.features = departamentos.features;

                this.geoJsonSource.data.features = this.departamentos;
                console.log("Departamentos cargados: ", this.departamentos.length);

                // map.on('mouseenter', 'places', function(e) {
                //     // Change the cursor style as a UI indicator.
                //     map.getCanvas().style.cursor = 'pointer';
                //
                //     var coordinates = e.features[0].geometry.coordinates.slice();
                //     var description = e.features[0].properties.description;
                //
                //     // Ensure that if the map is zoomed out such that multiple
                //     // copies of the feature are visible, the popup appears
                //     // over the copy being pointed to.
                //     while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                //         coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                //     }
                //
                //     // Populate the popup and set its coordinates
                //     // based on the feature found.
                //     popup
                //         .setLngLat(coordinates)
                //         .setHTML(description)
                //         .addTo(map);
                // });
                //
                // map.on('mouseleave', 'places', function() {
                //     map.getCanvas().style.cursor = '';
                //     popup.remove();
                // });
            },

            aplicarFiltro() {
                let campo = this.pintarPor;
                console.log('Aplico filtro por', this.pintarPor);

                let plasma = ['#ffffff','#ffffe5','#ffffcc','#ffeda0','#fed976','#feb24c','#fd8d3c','#fc4e2a','#e31a1c','#bd0026','#800026'];

                let escala = [];
                if (campo==="personas") {
                    escala = [0, 5000, 10000, 50000, 100000, 250000, 500000, 1000000];
                } else if (campo==="viviendas_") {
                    escala = [0, 1000, 5000, 10000, 25000, 50000, 100000];
                } else if (campo==="prop_hombres" || campo==="prop_mujeres") {
                    escala = [0, 0.4, 0.45, 0.5, 0.55, 0.6, 0.8, 1];
                } else if (campo==="semaforo") {
                    plasma = ['#90be6d', '#ffe066', '#f25f5c'];
                    escala = [0, 1, 2];
                } else {
                    escala = [0, 50000, 100000, 250000, 500000, 1000000];
                }

                let corte = Math.floor(plasma.length / escala.length);

                let _colores = [];
                for (let i = 0; i < escala.length; i++) {
                    _colores.push(escala[i]);
                    _colores.push(plasma[i*corte]);
                    // let dato = plasma[i * corte];
                    // colores.push('rgba(' + (dato[0] * 255) + ',' + (dato[1] * 255) + ',' + (dato[2] * 255) + ',1)');
                }

                let color = [
                    'interpolate',
                    ['linear'],
                    ['get', campo],
                    ..._colores
                    // 0, 'rgba('+(0.050383*255)+','+(0.029803*255)+','+(0.527975*255)',1)',
                    // 20, 'pink',
                    // 50, 'orange',
                    // 100, 'red'
                ];

                console.log(color);
                this.map.setPaintProperty('layer-departamentos', 'fill-color', color);

            }
        }
    }
</script>

<style scoped>
    #map {
        width: 600px;
        height: 400px;
    }
    .popup {
        z-index: 99;
    }
</style>